import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const CalendarOneIcon: SVGFC = ({ color = tailwindColors.grey.lighter, fill, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6 5.6H16V4.8C16 4.58783 15.9157 4.38434 15.7657 4.23431C15.6157 4.08429 15.4122 4 15.2 4C14.9878 4 14.7843 4.08429 14.6343 4.23431C14.4843 4.38434 14.4 4.58783 14.4 4.8V5.6H9.6V4.8C9.6 4.58783 9.51571 4.38434 9.36569 4.23431C9.21566 4.08429 9.01217 4 8.8 4C8.58783 4 8.38434 4.08429 8.23431 4.23431C8.08429 4.38434 8 4.58783 8 4.8V5.6H6.4C5.76348 5.6 5.15303 5.85286 4.70294 6.30294C4.25286 6.75303 4 7.36348 4 8V17.6C4 18.2365 4.25286 18.847 4.70294 19.2971C5.15303 19.7471 5.76348 20 6.4 20H17.6C18.2365 20 18.847 19.7471 19.2971 19.2971C19.7471 18.847 20 18.2365 20 17.6V8C20 7.36348 19.7471 6.75303 19.2971 6.30294C18.847 5.85286 18.2365 5.6 17.6 5.6ZM18.4 17.6C18.4 17.8122 18.3157 18.0157 18.1657 18.1657C18.0157 18.3157 17.8122 18.4 17.6 18.4H6.4C6.18783 18.4 5.98434 18.3157 5.83431 18.1657C5.68429 18.0157 5.6 17.8122 5.6 17.6V12H18.4V17.6ZM18.4 10.4H5.6V8C5.6 7.78783 5.68429 7.58434 5.83431 7.43431C5.98434 7.28429 6.18783 7.2 6.4 7.2H8V8C8 8.21217 8.08429 8.41566 8.23431 8.56569C8.38434 8.71571 8.58783 8.8 8.8 8.8C9.01217 8.8 9.21566 8.71571 9.36569 8.56569C9.51571 8.41566 9.6 8.21217 9.6 8V7.2H14.4V8C14.4 8.21217 14.4843 8.41566 14.6343 8.56569C14.7843 8.71571 14.9878 8.8 15.2 8.8C15.4122 8.8 15.6157 8.71571 15.7657 8.56569C15.9157 8.41566 16 8.21217 16 8V7.2H17.6C17.8122 7.2 18.0157 7.28429 18.1657 7.43431C18.3157 7.58434 18.4 7.78783 18.4 8V10.4Z"
        fill={fill || color}
      />
    </svg>
  )
}

export default CalendarOneIcon
